import React, { useEffect, useState } from 'react';

import styled, { css } from 'styled-components';
import { StyledTextField } from 'styles/common';

export const InputPaddingCSS = css`
  padding: 0.5rem 0.75rem;
`;
const EditableTextField = styled(StyledTextField)`
  .MuiInputBase-root {
    font-size: ${({ size, ...props }) =>
      size === 'large' ? props.theme.typography.h4.fontSize : props.theme.typography.body2.fontSize};
    ${(props) =>
      props.bold &&
      css`
        font-weight: 600;
      `}
  }
  border-color: ${(props) => props.theme.palette.borders.lightGrey} !important;
  .Mui-focused fieldset,
  &:hover fieldset {
    border-width: 1px;
    border-color: ${(props) => props.theme.palette.borders.primary} !important;
  }
  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}
  margin-left: 1rem;
`;

export const CreateGoalDescriptionField = ({ value = null, defaultValue = null, onUpdate, onKeyDown }) => {
  const [localDescription, setLocalDescription] = useState(value);

  const handleChange = (ev) => {
    setLocalDescription(ev.target.value);
  };

  const handleBlur = (ev) => {
    const { value } = ev.target;

    onUpdate(String(value).trim());
  };

  useEffect(() => {
    setLocalDescription(value);
  }, [value]);

  return (
    <EditableTextField
      fullWidth
      variant="outlined"
      size="small"
      value={localDescription}
      defaultValue={defaultValue}
      placeholder="Add details"
      multiline
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={onKeyDown}
    />
  );
};

export default CreateGoalDescriptionField;
